import { Box, Flex, SimpleGrid, Text, Tooltip } from '@chakra-ui/react';
import { InfoCircle, useDashboardStore } from '@devd-client/devd/components';
import { useSummaryGql } from '../../graphql';
import { useCallback, useState } from 'react';
import SlideDrawer from './SlideDrawer';
import { QuickInsightItem } from './types';
import { QuickInsightCard } from './QuickInsightCard';

export const QuickInsights = () => {
  const { selected, selectedTeam } = useDashboardStore();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  const { data: prData, isFetching: prLoading } = useSummaryGql(
    'pr',
    selectedTeam.value,
    selected.startDate,
    selected.endDate,
    selected?.sprintId
  );

  const { data: taskData, isFetching: taskLoading } = useSummaryGql(
    'task',
    selectedTeam.value,
    selected.startDate,
    selected.endDate,
    selected?.sprintId
  );

  const { data: contributorData, isFetching: contributorLoading } =
    useSummaryGql(
      'contributor',
      selectedTeam.value,
      selected.startDate,
      selected.endDate,
      selected?.sprintId
    );

  const handleDrawerOpen = useCallback(() => setOpenDrawer(true), []);
  const handleDrawerClose = useCallback(() => setOpenDrawer(false), []);

  const cardData: QuickInsightItem[] = [
    {
      summary: contributorData?.summary,
      previousPeriodStat: contributorData?.previousPeriodStat,
      isLoading: contributorLoading,
      onClickCard: handleDrawerOpen,
      disableLink: true,
    },
    {
      summary: prData?.summary,
      previousPeriodStat: prData?.previousPeriodStat,
      isLoading: prLoading,
    },
    {
      summary: taskData?.summary,
      previousPeriodStat: taskData?.previousPeriodStat,
      isLoading: taskLoading,
    },
  ];

  return (
    <Flex mt={6} w="full" direction="column">
      <Flex align="center" mb={4}>
        <Text mr={1} fontFamily="heading" fontSize="xl" fontWeight="semibold">
          Quick Insights
        </Text>
        <Tooltip
          hasArrow
          aria-label="quick-insights"
          label="A quick snapshot of your team's key throughput metrics for the selected period."
        >
          <Box>
            <InfoCircle />
          </Box>
        </Tooltip>
      </Flex>

      <SimpleGrid columns={3} spacing={4}>
        {cardData.map((item, index) => (
          <QuickInsightCard key={index} {...item} />
        ))}
      </SimpleGrid>

      {openDrawer && (
        <SlideDrawer
          openDrawer={openDrawer}
          handleDrawerClose={handleDrawerClose}
          team={selectedTeam.value}
          selected={selected}
        />
      )}
    </Flex>
  );
};
